import React from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import { makeCommunityUrl } from 'Components/new/links/community-link'

export interface MoreTabItem {
  chi_name: string
  tab_name: string
}
interface IProps {
  more_tab_list: MoreTabItem[]
  currentMoreTab: string
  series_id: string
  handleMoreTabClick: (e: React.MouseEvent) => void
}

const MoreTabList = ({
  more_tab_list,
  currentMoreTab,
  series_id,

  handleMoreTabClick,
}: IProps) => {
  const activeTab = currentMoreTab === 'wenda' ? 'all' : currentMoreTab
  return (
    <div className="tw-flex  tw-text-12  tw--ml-6">
      {more_tab_list?.map((item) => {
        const { chi_name, tab_name } = item
        return (
          <Link
            key={tab_name}
            href={`/new_community`}
            as={makeCommunityUrl({ id: series_id, tab: tab_name })}
          >
            <a
              // className="list-item"
              className={classNames('tab-item tw-flex tw-items-center', {
                bg: activeTab === tab_name,
              })}
              data-name={chi_name}
              onClick={(e: any) => handleMoreTabClick(e)}
            >
              <h2 data-name={tab_name}>{chi_name}</h2>
            </a>
          </Link>
        )
      })}

      <style jsx>
        {`
          .tab-item {
            width: auto;
            height: 28px;
            margin: 0 6px;
            padding: 4px 12px;
            border-radius: 2px;
            background-color: #e6e8f2;
          }
          .tab-item:hover {
            color: black;
            font-weight: 500;
          }
          .bg {
            background-color: #1f2129;
            color: white !important;
          }
        `}
      </style>
    </div>
  )
}

export default MoreTabList
